module.exports = __webpack_public_path__ + "static/media/mmu_logo.85268c99.svg";